import { useFormik } from 'formik'
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import Swal from 'sweetalert2'
import { DeleteDepartamento } from '../../../Actions/DepartamentoAction'
import {
    editByIdDepartamentos,
    getAllDepartamentosV2,
    saveDepartamentoImportar,
    saveDepartamentos,
} from '../../../Services/departamentoService'
import * as Yup from 'yup'
import { saveError } from '../../../Services/errorService'
import { departamentosExcel } from '../../../Services/reporteService'
import { createForm } from '../helpers/formik.config'
import showImportResult, { showImportError } from '../../../utils/showImportResult'
const useDepartment = (history, location) => {
    const [file, setFile] = useState(null)
    const [isLoading, setIsLoading] = useState(false)
    const dispatch = useDispatch()
    const eliminarDepartamento = (id) => dispatch(DeleteDepartamento(id))

    const handleImprimir = async () => {
        try {
            const departamentos = await getAllDepartamentosV2(
                true,
                0,
                '',
                50000
            )
            const excel = await departamentosExcel(
                departamentos.data.content,
                null
            )

            const byteCharacters = atob(excel.data)
            const byteNumbers = new Array(byteCharacters.length)
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i)
            }
            const byteArray = new Uint8Array(byteNumbers)
            const blob = new Blob([byteArray], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            })

            const url = window.URL.createObjectURL(blob)
            const link = document.createElement('a')
            link.href = url
            link.download = 'departamentos.xlsx'
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
            window.URL.revokeObjectURL(url)
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Hubo un problema al generar el archivo.',
                showConfirmButton: true,
            })
        }
    }

    //add department:
    const formikCreate = useFormik({
        initialValues: createForm.intialValues,
        validationSchema: createForm.validationSchema,
        onSubmit: (values) => addDepartamento(values),
    })

    const addDepartamento = (values) => {
        // creamos el departamento
        let departamento = {
            ...values,
        }

        saveDepartamentos(departamento)
            .then((res) => {
                history.goBack()
            })
            .catch(async (error) => {
                const errorData = {
                    mensaje: 'Error al intentar crear un departamento',
                    detalle: error.response.data.message,
                    entidad: 'DEPARTAMENTO',
                    tipo: 'WEBAPP',
                    severidad: 'HIGH',
                    reportado: 'APPLICATION',
                }

                await saveError(errorData)
                Swal.fire({
                    title: 'Faltan datos o algunos son incorrectos.',
                    text: error.response.data.message,
                    type: 'error',
                    showConfirmButton: false,
                    timer: 2000,
                })
            })
    }

    //AddDepartamento.js

    const handleSubmit = (e) => {
        e.preventDefault()

        const formData = new FormData()
        formData.append('file', file)

        setIsLoading(true)
        saveDepartamentoImportar(formData)
            .then((data) => {
                showImportResult(data, 'departamentos')
            })
            .catch(() => {
                showImportError('departamentos')
            })
            .finally(() => setIsLoading(false))
    }

    //EditDepartamento.js

    const departamento = location?.state?.departamento

    const formikEdit = useFormik({
        initialValues: {
            nombre: departamento?.nombre || '',
            tasaIva: departamento?.tasaIva ?? '',
        },
        validationSchema: Yup.object({
            nombre: Yup.string().required('Obligatorio'),
            tasaIva: Yup.number()
                .required('Obligatorio')
                .min(0, 'El IVA no puede ser menor a 0'),
        }),
        onSubmit: (values) => editDepartamento(values),
        enableReinitialize: true, // Para que tome el estado inicial si cambia
    })

    const editDepartamento = (values) => {
        const departamentoUpdated = {
            ...values,
            id: departamento.id,
        }

        editByIdDepartamentos(departamentoUpdated)
            .then(() => {
                history.goBack()
            })
            .catch(async (error) => {
                const errorData = {
                    mensaje: 'Error al intentar editar un departamento',
                    detalle: error?.message || '',
                    entidad: 'DEPARTAMENTO',
                    tipo: 'WEBAPP',
                    severidad: 'HIGH',
                    reportado: 'APPLICATION',
                }

                await saveError(errorData)
                Swal.fire({
                    text: 'Error al editar el departamento, verifique los datos.',
                    icon: 'error',
                    showConfirmButton: false,
                    timer: 1500,
                })
                console.error(error?.response?.data)
            })
    }

    return {
        handleImprimir,
        eliminarDepartamento,
        formikCreate,
        file,
        setFile,
        handleSubmit,
        isLoading,
        formikEdit,
    }
}

export default useDepartment
